
import { IThongKeSiSoSelectRequest } from "../../../models/request/thong-ke/IThongKeSiSoSelectRequest";
import { IThongKeItemBaseRespone } from "../../../models/response/thong-ke/IThongKeItemBaseRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThongKeCRMActionDefine = {

    LOAD_BY_CHIEN_DICH_START: {} as IThongKeSiSoSelectRequest,
    LOAD_BY_CHIEN_DICH_SUCCESS: {} as IThongKeItemBaseRespone[],
    LOAD_BY_CHIEN_DICH_ERROR: "",
    LOAD_BY_NGUON_BIET_TOI_START: {} as IThongKeSiSoSelectRequest,
    LOAD_BY_NGUON_BIET_TOI_SUCCESS: {} as IThongKeItemBaseRespone[],
    LOAD_BY_NGUON_BIET_TOI_ERROR: "",

}
export const eThongKeCRMActionTypeIds = generateActionTypeIds(eThongKeCRMActionDefine, "THONG_KE_CRM")

export type IThongKeCRMActionTypes = IGenericActionType<typeof eThongKeCRMActionDefine, "THONG_KE_CRM">